<template>
  <modal
    class="_custom js-auth-modal"
    :name="name"
    :scrollable="isScrollable"
    :adaptive="true"
    :width="width"
    :height="height"
    :click-to-close="isClosableToOverlay"
    @before-open="handlerBeforeOpen"
    @before-close="handlerBeforeClose"
    @opened="handlerOpened"
    @closed="handlerClosed"
  >
    <div class="modal-desktop" :class="rootClassModal">
      <div v-if="showHeader" class="modal-desktop__header">
        <button
          v-if="showBack"
          class="modal-desktop__back"
          type="button"
          aria-label="Назад"
          @click.prevent="onBack"
        >
          <svg
            class="modal-desktop__back-icon"
            :width="24"
            :height="24"
          >
            <use xlink:href="#Arrow_back_24" />
          </svg>
        </button>
        <button
          v-if="showClose"
          class="modal-desktop__close"
          type="button"
          aria-label="Закрыть"
          @click.prevent="onHide"
        >
          <svg
            class="modal-desktop__close-icon"
            :width="24"
            :height="24"
          >
            <use xlink:href="#Close_24" />
          </svg>
        </button>
      </div>
      <div class="modal-desktop__container">
        <slot></slot>
      </div>
    </div>
  </modal>
</template>

<script>
import { closed, opened, blockScroll, unlockScroll } from '@/js/utils/modals/openedClosedModals';

export default {
  name: 'ModalVueD',
  props: {
    name: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: 'auto',
    },
    classModal: {
      type: [String, Array, Object],
      default: '',
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    isClosableToOverlay: {
      type: Boolean,
      default: true,
    },
    isScrollable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showHeader() {
      return this.showClose || this.showBack;
    },
    rootClassModal() {
      return [
        this.classModal,
        {
          '_no-header': !this.showHeader,
        },
      ];
    },
  },
  methods: {
    onHide() {
      this.$modal.hide(this.name);
      this.$emit('hide');
    },
    onBack() {
      this.$emit('bake');
    },
    handlerBeforeOpen() {
      this.$emit('before-open');
      blockScroll();
      opened();
    },
    handlerBeforeClose() {
      this.$emit('before-close');
      unlockScroll();
    },
    handlerOpened() {
      this.$emit('opened');
    },
    handlerClosed(event) {
      this.$emit('closed', event);
      closed();
    },
  },
};
</script>
